module.exports = __webpack_public_path__ + "img/intro.d40851da.jpeg";